// extracted by mini-css-extract-plugin
module.exports = {"passWrapper":"edit_passWrapper__1eTJE","changePhoto":"edit_changePhoto__3ZgfB"};